import { createContext, ReactNode, useContext, useState } from 'react';

type ReloadIframeContextType = {
	reload: boolean;
	isIframeLoading: boolean;
	triggerReload: () => void;
	setIframeLoading: (loading: boolean) => void;
};

const ReloadIframeContext = createContext<ReloadIframeContextType>({
	reload: false,
	isIframeLoading: true,
	triggerReload: () => {},
	setIframeLoading: () => {},
});

export const useReloadIframe = () => useContext(ReloadIframeContext);

type ReloadIframeProviderProps = {
	children: ReactNode;
};

export const ReloadIframeProvider = ({ children }: ReloadIframeProviderProps) => {
	const [reload, setReload] = useState(false);
	const [isIframeLoading, setIframeLoading] = useState(true);

	const triggerReload = () => {
		setReload((prev) => !prev);
		setIframeLoading(true);
	};

	return (
		<ReloadIframeContext.Provider value={{ reload, isIframeLoading, triggerReload, setIframeLoading }}>
			{children}
		</ReloadIframeContext.Provider>
	);
};
